<app-example-format
  [title]="componentInfo.title"
  urlTSDocs="https://docs.kadaster.nl/ggc/ggs-ggc-library/tsdocs/classes/ggc-dataset-switcher_src_lib_dataset-switcher_ggc-dataset-switcher.component.GgcSearchLocationComponent.html"
  urlVoorbeelden=""
  urlChangelog=""
  [codeHtmlPath]="'code/examples/example-dataset-switcher/example-dataset-switcher-radio-buttons/example-dataset-switcher-radio-buttons.component.html'"
  [codeTypescriptPath]="'code/examples/example-dataset-switcher/example-dataset-switcher-radio-buttons/example-dataset-switcher-radio-buttons.component.ts'"
  [codeScssPath]="'code/examples/example-dataset-switcher/example-dataset-switcher-radio-buttons/example-dataset-switcher-radio-buttons.component.scss'"
  urlCodeHtml="example-snapping/example-dataset-switcher/example-dataset-switcher-radio-buttons/example-dataset-switcher-radio-buttons.component.html"
  urlCodeTypescript="example-snapping/example-dataset-switcher/example-dataset-switcher-radio-buttons/example-dataset-switcher-radio-buttons.component.ts"
  urlCodeScss="example-snapping/example-dataset-switcher/example-dataset-switcher-radio-buttons/example-dataset-switcher-radio-buttons.component.scss"
  kaartConfigFilePath="code/examples/example-dataset-switcher/example-dataset-switcher-kaartconfig.json"
  treeConfigFilePath="code/examples/example-dataset-switcher/example-dataset-switcher-treeconfig.json"
  urlKaartConfig="example-dataset-switcher/example-dataset-switcher-kaartconfig.json"
  urlTreeConfig="example-dataset-switcher/example-dataset-switcher-treeconfig.json"
>
  @if (componentInfo.tags && componentInfo.tags?.length > 0) {
    <div page-labels>
      @for (tag of componentInfo.tags; track tag) {
        <span class="badge bg-primary mx-1">{{ tag.toLocaleLowerCase() }}</span>
      }
    </div>
  }

  <div page-introduction>
    <p>
      {{ componentInfo.introduction }}
    </p>
    <p>
      Deze functie wordt vaak gebruikt om van achtergrondkaart te wisselen
      (bijvoorbeeld met een luchtfoto), maar kan ook gebruikt worden om een
      complete verzameling van kaartlagen te wisselen.
    </p>
    <p>
      Om de knoppen van de buttons te koppelen aan de kaartlagen, is het
      belangrijk om de <code>DatasetSwitcherButton</code> dezelfde naam te geven
      als de <code>themeName</code> uit de <code>datasetSwitcherConfig</code>.
      Deze naam wordt ook gebruikt bij het tonen van de knop.
    </p>
  </div>

  <div page-functionality>
    <div class="row">
      <!-- DOCS:START functionality -->
      <div class="col-md-3 col-sm-6">
        <ggc-dataset-switcher
          (events)="logSwitchEvent($event)"
          [themes]="datasetSwitcherConfig"
          [datasetSwitcherButtons]="datasetSwitcherButtons"
        ></ggc-dataset-switcher>
      </div>
      <div class="col-md-9 col-sm-10">
        <div class="map-container">
          <ggc-map [webServices]="mapConfig"></ggc-map>
        </div>
      </div>
      <!-- DOCS:END functionality -->
    </div>
  </div>

  <div page-tips>
    <p>
      Het stylen van de buttons is mogelijk door het overschrijven van de css
      classes <code>.ggc-ds-switcher-label</code>,
      <code>.ggc-ds-switcher-label-img</code>,
      <code>.ggc-ds-switcher-label-txt</code> en
      <code>.ggc-ds-switcher-radio-buttons</code>. Bekijk de SCSS voor een
      voorbeeld hiervan.
    </p>
  </div>
</app-example-format>
